import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

// array of triggers
const galleryTrigger = [
  ...document.querySelectorAll(".js-gallery-container a"),
];
const origin = window.location.origin;
const init = () => {
  // create items array adding necessary data.
  const items = [...document.querySelectorAll(".js-gallery-image")].map(
    (i, k) => {
      return {
        src: i.src || `${origin}${i.dataset.src}`,
        el: i,
        w: 800,
        h: 600,
      };
    },
  );

  //add click event to fire on each trigger.
  galleryTrigger.forEach((item, i) => {
    item.addEventListener("click", e => {
      handleClick(e, i);
    });
  });

  const handleClick = (e, i) => {
    // handleClick triggered when gallery anchor tag is clicked
    e.preventDefault();
    //find the image in the trigger and get the index
    if (i >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(i);
    }

    return false;
  };

  const openPhotoSwipe = index => {
    const pswpElement = document.querySelectorAll(".pswp")[0];
    const options = {
      index: index,
      history: false,
      getThumbBoundsFn: function(index) {
        const thumbnail = items[index].el;
        const pageYScroll =
          window.pageYOffset || document.documentElement.scrollTop;

        const rect = thumbnail.getBoundingClientRect();
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width,
        };
      },
    };

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    // Pass data to PhotoSwipe and initialize it
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options,
    );
    gallery.init();
  };
};

if (galleryTrigger.length) {
  //add template to page if it hasnt been added already
  if (!document.querySelector(".pswp")) {
    let template = document.createElement("div");
    template.innerHTML = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="pswp__bg"></div>
  <div class="pswp__scroll-wrap">
    <div class="pswp__container">
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
    </div>
    <div class="pswp__ui pswp__ui--hidden">
      <div class="pswp__top-bar">
        <div class="pswp__counter"></div>
        <button
          class="pswp__button pswp__button--close"
          title="Close (Esc)"
        ></button>
        <button class="pswp__button pswp__button--share" title="Share"></button>
        <button
          class="pswp__button pswp__button--fs"
          title="Toggle fullscreen"
        ></button>
        <button
          class="pswp__button pswp__button--zoom"
          title="Zoom in/out"
        ></button>
        <div class="pswp__preloader">
          <div class="pswp__preloader__icn">
            <div class="pswp__preloader__cut">
              <div class="pswp__preloader__donut"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
        <div class="pswp__share-tooltip"></div>
      </div>
      <button
        class="pswp__button pswp__button--arrow--left"
        title="Previous (arrow left)"
      ></button>
      <button
        class="pswp__button pswp__button--arrow--right"
        title="Next (arrow right)"
      ></button>
      <div class="pswp__caption">
        <div class="pswp__caption__center"></div>
      </div>
    </div>
  </div>
</div>`;
    document.body.appendChild(template);
  }

  document.addEventListener("DOMContentLoaded", () => {
    //add alt tag to every img on page
    document.querySelector(".skip-link").addEventListener("click", e => {
      e.preventDefault();
      const skipToTarget = document.querySelector(
        e.target.getAttribute("href"),
      );
      skipToTarget.setAttribute("tabIndex", 0);
      skipToTarget.focus();
    });

    if (galleryTrigger.length) {
      init();
    }
  });
}
